enum Roles {
    AcceptancesViewer = 'AcceptancesViewer',
    AcceptancesAdmin = 'AcceptancesAdmin',
    ActivityLogsViewer = 'ActivityLogsViewer',
    ActivityLogsAdmin = 'ActivityLogsAdmin',
    AddonsViewer = 'AddonsViewer',
    AddonsEditor = 'AddonsEditor',
    AddonsAdmin = 'AddonsAdmin',
    ApiKeysViewer = 'ApiKeysViewer',
    ApiKeysEditor = 'ApiKeysEditor',
    ApiKeysAdmin = 'ApiKeysAdmin',
    AppTypesViewer = 'AppTypesViewer',
    AppsViewer = 'AppsViewer',
    AppsEditor = 'AppsEditor',
    AppsAdmin = 'AppsAdmin',
    AppointmentBookingFlowSettingsViewer = 'AppointmentBookingFlowSettingsViewer',
    AppointmentBookingFlowSettingsEditor = 'AppointmentBookingFlowSettingsEditor',
    AppointmentBookingFlowSettingsAdmin = 'AppointmentBookingFlowSettingsAdmin',
    AppointmentsViewer = 'AppointmentsViewer',
    AppointmentsReportViewer = 'AppointmentsReportViewer',
    AppointmentsEditor = 'AppointmentsEditor',
    AppointmentsAdmin = 'AppointmentsAdmin',
    AppointmentsAdminSettingsSkip = 'AppointmentsAdminSettingsSkip',
    AppointmentsNotesViewer = 'AppointmentsNotesViewer',
    AppointmentsNotesEditor = 'AppointmentsNotesEditor',
    AppointmentsAllStaffNotesViewAccess = 'AppointmentsAllStaffNotesViewAccess',
    AppointmentsPrivateNotesViewAccess = 'AppointmentsPrivateNotesViewAccess',
    AppointmentsPrivateNotesAccess = 'AppointmentsPrivateNotesAccess',
    AppointmentsMarketingStatusViewer = 'AppointmentsMarketingStatusViewer',
    AppointmentsCustomStatusesViewer = 'AppointmentsCustomStatusesViewer',
    AppointmentsCustomStatusesEditor = 'AppointmentsCustomStatusesEditor',
    AppointmentsMaskedPriceRestrictionViewer = 'AppointmentsMaskedPriceRestrictionViewer',
    AvailabilityAdminSettingsSkip = 'AvailabilityAdminSettingsSkip',
    DynamicLinksAdmin = 'DynamicLinksAdmin',
    DynamicLinksViewer = 'DynamicLinksViewer',
    DynamicLinksEditor = 'DynamicLinksEditor',
    AreaCodesViewer = 'AreaCodesViewer',
    AreaCodesEditor = 'AreaCodesEditor',
    AreaCodesAdmin = 'AreaCodesAdmin',
    BillingAccountsViewer = 'BillingAccountsViewer',
    BillingAccountsEditor = 'BillingAccountsEditor',
    BillingAccountsAdmin = 'BillingAccountsAdmin',
    BillingSubscriptionsAdmin='BillingSubscriptionsAdmin',
    BlockHoursViewer = 'BlockHoursViewer',
    BlockHoursEditor = 'BlockHoursEditor',
    BlockHoursAdmin = 'BlockHoursAdmin',
    BookingPortalSettingsEditor = 'BookingPortalSettingsEditor',
    BookingPortalSettingsViewer = 'BookingPortalSettingsViewer',
    BookingPortalSettingsAdmin = 'BookingPortalSettingsAdmin',
    CalendarsViewer = 'CalendarsViewer',
    CalendarsEditor = 'CalendarsEditor',
    CalendarsAdmin = 'CalendarsAdmin',
    CartServiceViewer = 'CartServiceViewer',
    CartServiceEditor = 'CartServiceEditor',
    CartServiceAdmin = 'CartServiceAdmin',
    CategoriesViewer = 'CategoriesViewer',
    CategoriesEditor = 'CategoriesEditor',
    CategoriesAdmin = 'CategoriesAdmin',
    CertificatesViewer = 'CertificatesViewer',
    CertificatesEditor = 'CertificatesEditor',
    CertificatesAdmin = 'CertificatesAdmin',
    ChannelsViewer = 'ChannelsViewer',
    ChannelsEditor = 'ChannelsEditor',
    ChannelsAdmin = 'ChannelsAdmin',
    ClassPricesViewer = 'ClassPricesViewer',
    ClassPricesEditor = 'ClassPricesEditor',
    ClassPricesAdmin = 'ClassPricesAdmin',
    ClassSettingsViewer = 'ClassSettingsViewer',
    ClassSettingsEditor = 'ClassSettingsEditor',
    ClassSettingsAdmin = 'ClassSettingsAdmin',
    CompanyMastersViewer = 'CompanyMastersViewer',
    CompanyMastersEditor = 'CompanyMastersEditor',
    CompanyMastersAdmin = 'CompanyMastersAdmin',
    CompanySettingsEditor = 'CompanySettingsEditor',
    CompanySettingsAdmin = 'CompanySettingsAdmin',
    CompaniesEditor = 'CompaniesEditor',
    CompaniesAdmin = 'CompaniesAdmin',
    CompaniesViewer = 'CompaniesViewer',
    AnalyticsViewer = 'AnalyticsViewer',
    AnalyticsEditor = 'AnalyticsEditor',
    AnalyticsAdmin = 'AnalyticsAdmin',
    ConsumerRestrictionsViewer = 'ConsumerRestrictionsViewer',
    ConsumerRestrictionsEditor = 'ConsumerRestrictionsEditor',
    ConsumerRestrictionsAdmin = 'ConsumerRestrictionsAdmin',
    CreditsViewer = 'CreditsViewer',
    CreditsAdmin = 'CreditsAdmin',
    CustomAttributesViewer = 'CustomAttributesViewer',
    CustomAttributesEditor = 'CustomAttributesEditor',
    CustomAttributesAdmin = 'CustomAttributesAdmin',
    CustomStatusesViewer = 'CustomStatusesViewer',
    CustomStatusesEditor = 'CustomStatusesEditor',
    CustomStatusesAdmin = 'CustomStatusesAdmin',
    CustomerSettingsRestrictionViewer = 'CustomerSettingsRestrictionViewer',
    CustomerSettingsRestrictionEditor = 'CustomerSettingsRestrictionEditor',
    CustomerSettingsRestrictionAdmin = 'CustomerSettingsRestrictionAdmin',
    CustomerStaffLinksViewer = 'CustomerStaffLinksViewer',
    CustomerStaffLinksAdmin = 'CustomerStaffLinksAdmin',
    UseCustomerStaffLinking = 'UseCustomerStaffLinking',
    CustomersViewer = 'CustomersViewer',
    CustomersEditor = 'CustomersEditor',
    CustomersAdmin = 'CustomersAdmin',
    CustomersContactViewer = 'CustomersContactViewer',
    CustomersNotesViewer = 'CustomersNotesViewer',
    CustomersNotesEditor = 'CustomersNotesEditor',
    CustomersAllStaffNotesViewAccess = 'CustomersAllStaffNotesViewAccess',
    CustomersPrivateNotesViewAccess = 'CustomersPrivateNotesViewAccess',
    CustomersPrivateNotesAccess = 'CustomersPrivateNotesAccess',
    CustomersDataActivityViewer = 'CustomersDataActivityViewer',
    CustomersDataStatsViewer = 'CustomersDataStatsViewer',
    CustomersDataBasicStatsViewer = 'CustomersDataBasicStatsViewer',
    CustomerReportsViewer = 'CustomerReportsViewer',
    CustomerReportsSalesViewer = 'CustomerReportsSalesViewer',
    DepartmentsViewer = 'DepartmentsViewer',
    DepartmentsEditor = 'DepartmentsEditor',
    DepartmentsAdmin = 'DepartmentsAdmin',
    DesignationsViewer = 'DesignationsViewer',
    DesignationsEditor = 'DesignationsEditor',
    DesignationsAdmin = 'DesignationsAdmin',
    DiscountsViewer = 'DiscountsViewer',
    DiscountsEditor = 'DiscountsEditor',
    DiscountsAdmin = 'DiscountsAdmin',
    WalletItemsViewer = 'WalletItemsViewer',
    WalletItemsEditor = 'WalletItemsEditor',
    WalletItemsAdmin = 'WalletItemsAdmin',
    EmployeeSettingsViewer = 'EmployeeSettingsViewer',
    EmployeeSettingsEditor = 'EmployeeSettingsEditor',
    EmployeeSettingsAdmin = 'EmployeeSettingsAdmin',
    EmployeesViewer = 'EmployeesViewer',
    EmployeesEditor = 'EmployeesEditor',
    EmployeesAdmin = 'EmployeesAdmin',
    ExtendedFieldSubmissionsAdmin = 'ExtendedFieldSubmissionsAdmin',
    ExtensionsViewer = 'ExtensionsViewer',
    ExtensionsEditor = 'ExtensionsEditor',
    ExtensionsAdmin = 'ExtensionsAdmin',
    FeatureNotificationsViewer = 'FeatureNotificationsViewer',
    FeatureNotificationsAdmin = 'FeatureNotificationsAdmin',
    GiftCertificatesViewer = 'GiftCertificatesViewer',
    GiftCertificatesEditor = 'GiftCertificatesEditor',
    GiftCertificatesAdmin = 'GiftCertificatesAdmin',
    GiftCertificateWalletsViewer = 'GiftCertificateWalletsViewer',
    GiftCertificateWalletsEditor = 'GiftCertificateWalletsEditor',
    GiftCertificateWalletsAdmin = 'GiftCertificateWalletsAdmin',
    GiftCertificateWalletsCodeViewer = 'GiftCertificateWalletsCodeViewer',
    GroupSettingsAdmin = 'GroupSettingsAdmin',
    GroupsViewer = 'GroupsViewer',
    GroupsEditor = 'GroupsEditor',
    GroupsAdmin = 'GroupsAdmin',
    IntakeFormsViewer = 'IntakeFormsViewer',
    IntakeFormsEditor = 'IntakeFormsEditor',
    IntakeFormsLinkingManager = 'IntakeFormsLinkingManager',
    IntakeFormsAdmin = 'IntakeFormsAdmin',
    IntakeFormsForceDeleteWithSubmissions = 'IntakeFormsForceDeleteWithSubmissions',
    IntakeFormSubmissionsViewer = 'IntakeFormSubmissionsViewer',
    IntakeFormSubmissionsEditor = 'IntakeFormSubmissionsEditor',
    IntakeFormSubmissionsAdmin = 'IntakeFormSubmissionsAdmin',
    IntakeFormSubmissionsSkipValidations = 'IntakeFormSubmissionsSkipValidations',
    IntegrationsViewer = 'IntegrationsViewer',
    IntegrationsEditor = 'IntegrationsEditor',
    IntegrationsAdmin = 'IntegrationsAdmin',
    InvoicesViewer = 'InvoicesViewer',
    InvoicesAdmin = 'InvoicesAdmin',
    JsonUploadAdmin = 'JsonUploadAdmin',
    LicenseWalletsViewer = 'LicenseWalletsViewer',
    LicenseWalletsAdmin = 'LicenseWalletsAdmin',
    LinksViewer = 'LinksViewer',
    LinksEditor = 'LinksEditor',
    LinksAdmin = 'LinksAdmin',
    LocalesViewer = 'LocalesViewer',
    LocalesAdmin = 'LocalesAdmin',
    LocationsViewer = 'LocationsViewer',
    LocationsEditor = 'LocationsEditor',
    LocationsAdmin = 'LocationsAdmin',
    MembershipsViewer = 'MembershipsViewer',
    MembershipsEditor = 'MembershipsEditor',
    MembershipsAdmin = 'MembershipsAdmin',
    PlansViewer = 'PlansViewer',
    PlansEditor = 'PlansEditor',
    PlansAdmin = 'PlansAdmin',
    PlanWalletsViewer = 'PlanWalletsViewer',
    PlanWalletsEditor = 'PlanWalletsEditor',
    PlanWalletsAdmin = 'PlanWalletsAdmin',
    ProjectsViewer = 'ProjectsViewer',
    ProjectsEditor = 'ProjectsEditor',
    ProjectsAdmin = 'ProjectsAdmin',
    MembershipWalletsViewer = 'MembershipWalletsViewer',
    MembershipWalletsEditor = 'MembershipWalletsEditor',
    MembershipWalletsAdmin = 'MembershipWalletsAdmin',
    MessagingEventServiceViewer = 'MessagingEventServiceViewer',
    MessagingEventServiceEditor = 'MessagingEventServiceEditor',
    MessagingEventServiceAdmin = 'MessagingEventServiceAdmin',
    MessagingServiceViewer = 'MessagingServiceViewer',
    MessagingServiceEditor = 'MessagingServiceEditor',
    MessagingServiceAdmin = 'MessagingServiceAdmin',
    MessageCounterViewer = 'MessageCounterViewer',
    MessageCounterAdmin = 'MessageCounterAdmin',
    QueryServiceViewer = 'QueryServiceViewer',
    QueryServiceEditor = 'QueryServiceEditor',
    QueryServiceAdmin = 'QueryServiceAdmin',
    SuperAdmin = 'SuperAdmin',
    GroupLevel = 'GroupLevel',
    CompanyLevel = 'CompanyLevel',
    LocationLevel = 'LocationLevel',
    ServiceProviderLevel = 'ServiceProviderLevel',
    CustomerLevel = 'CustomerLevel',
    UserLevel = 'UserLevel',
    PrintReport = 'PrintReport',
    NotesViewer = 'NotesViewer',
    NotesEditor = 'NotesEditor',
    NotesAdmin = 'NotesAdmin',
    NotesPrivateAccess = 'NotesPrivateAccess',
    NotesAllStaffViewAccess = 'NotesAllStaffViewAccess',
    NotificationLogsViewer = 'NotificationLogsViewer',
    NotificationLogsAdmin = 'NotificationLogsAdmin',
    NotificationPreferencesViewer = 'NotificationPreferencesViewer',
    NotificationPreferencesEditor = 'NotificationPreferencesEditor',
    NotificationPreferencesAdmin = 'NotificationPreferencesAdmin',
    NotificationReceiversViewer = 'NotificationReceiversViewer',
    NotificationReceiversEditor = 'NotificationReceiversEditor',
    NotificationReceiversAdmin = 'NotificationReceiversAdmin',
    NotificationSettingServiceViewer = 'NotificationSettingServiceViewer',
    NotificationSettingServiceEditor = 'NotificationSettingServiceEditor',
    NotificationSettingServiceAdmin = 'NotificationSettingServiceAdmin',
    NotificationEventSettingsServiceViewer = 'NotificationEventSettingsServiceViewer',
    NotificationEventSettingsServiceAdmin = 'NotificationEventSettingsServiceAdmin',
    OpenHoursViewer = 'OpenHoursViewer',
    OpenHoursEditor = 'OpenHoursEditor',
    OpenHoursAdmin = 'OpenHoursAdmin',
    OrdersViewer = 'OrdersViewer',
    OrdersAdmin = 'OrdersAdmin',
    OrdersReportViewer = 'OrdersReportViewer',
    OrdersMaskedPriceRestrictionViewer = 'OrdersMaskedPriceRestrictionViewer',
    PackageServiceViewer = 'PackageServiceViewer',
    PackageServiceEditor = 'PackageServiceEditor',
    PackageServiceAdmin = 'PackageServiceAdmin',
    PackageWalletsViewer = 'PackageWalletsViewer',
    PackageWalletsAdmin = 'PackageWalletsAdmin',
    ManualRefundsAdmin = 'ManualRefundsAdmin',
    PaymentRequestsAdmin = 'PaymentRequestsAdmin',
    PaymentsManagerAdmin = 'PaymentsManagerAdmin',
    PoliciesViewer = 'PoliciesViewer',
    PoliciesEditor = 'PoliciesEditor',
    PoliciesAdmin = 'PoliciesAdmin',
    PublicKeysViewer = 'PublicKeysViewer',
    PublicKeysEditor = 'PublicKeysEditor',
    PublicKeysAdmin = 'PublicKeysAdmin',
    RecentsViewer = 'RecentsViewer',
    RecentsEditor = 'RecentsEditor',
    RecentsAdmin = 'RecentsAdmin',
    ReplyServiceViewer = 'ReplyServiceViewer',
    ReplyServiceEditor = 'ReplyServiceEditor',
    ReplyServiceAdmin = 'ReplyServiceAdmin',
    RequestAppsViewer = 'RequestAppsViewer',
    RequestAppsEditor = 'RequestAppsEditor',
    RequestAppsAdmin = 'RequestAppsAdmin',
    ResourceTypeSettingsViewer = 'ResourceTypeSettingsViewer',
    ResourceTypeSettingsEditor = 'ResourceTypeSettingsEditor',
    ResourceTypeSettingsAdmin = 'ResourceTypeSettingsAdmin',
    ResourceTypesViewer = 'ResourceTypesViewer',
    ResourceTypesEditor = 'ResourceTypesEditor',
    ResourceTypesAdmin = 'ResourceTypesAdmin',
    ResourcesViewer = 'ResourcesViewer',
    ResourcesEditor = 'ResourcesEditor',
    ResourcesAdmin = 'ResourcesAdmin',
    ReviewMailSettingsAdmin = 'ReviewMailSettingsAdmin',
    AppointmentReviewMailSettingsAdmin = 'AppointmentReviewMailSettingsAdmin',
    ClassReviewMailSettingsAdmin = 'ClassReviewMailSettingsAdmin',
    ReviewsAdmin = 'ReviewsAdmin',
    ReviewPageSettingsAdmin = 'ReviewPageSettingsAdmin',
    ReviewSettingsAdmin = 'ReviewSettingsAdmin',
    ReviewHelpfulServiceViewer = 'ReviewHelpfulServiceViewer',
    ReviewHelpfulServiceAdmin = 'ReviewHelpfulServiceAdmin',
    RolesViewer = 'RolesViewer',
    RolesDesignationRoleViewer = 'RolesDesignationRoleViewer',
    RolesEditor = 'RolesEditor',
    RolesAssignee = 'RolesAssignee',
    RolesAdmin = 'RolesAdmin',
    JNJIsCustom = 'JNJIsCustom',
    ServicePricesEditor = 'ServicePricesEditor',
    ServicePricesAdmin = 'ServicePricesAdmin',
    ServiceSettingsViewer = 'ServiceSettingsViewer',
    ServiceSettingsEditor = 'ServiceSettingsEditor',
    ServiceSettingsAdmin = 'ServiceSettingsAdmin',
    ServiceTemplatesViewer = 'ServiceTemplatesViewer',
    ServiceTemplatesEditor = 'ServiceTemplatesEditor',
    ServiceTemplatesAdmin = 'ServiceTemplatesAdmin',
    ServicesEditor = 'ServicesEditor',
    ServicesViewer = 'ServicesViewer',
    ServicesAdmin = 'ServicesAdmin',
    ServicesServiceCreatorTemplate = 'ServicesServiceCreatorTemplate',
    ServicesServicePoliciesAttache = 'ServicesServicePoliciesAttache',
    ServicesServicePoliciesViewer = 'ServicesServicePoliciesViewer',
    ShortUrlsViewer = 'ShortUrlsViewer',
    ShortUrlsEditor = 'ShortUrlsEditor',
    ShortUrlsAdmin = 'ShortUrlsAdmin',
    SlugsViewer = 'SlugsViewer',
    SlugsAdmin = 'SlugsAdmin',
    StaffProfilesViewer = 'StaffProfilesViewer',
    StaffProfilesEditor = 'StaffProfilesEditor',
    StaffProfilesAdmin = 'StaffProfilesAdmin',
    StarredsViewer = 'StarredsViewer',
    StarredsEditor = 'StarredsEditor',
    StarredsAdmin = 'StarredsAdmin',
    StudentsViewer = 'StudentsViewer',
    StudentsEditor = 'StudentsEditor',
    StudentsAdmin = 'StudentsAdmin',
    ParentViewer = 'ParentViewer',
    TasksViewer = 'TasksViewer',
    TasksEditor = 'TasksEditor',
    TasksAdmin = 'TasksAdmin',
    TemplateSettingsViewer = 'TemplateSettingsViewer',
    TemplateSettingsEditor = 'TemplateSettingsEditor',
    TemplateSettingsAdmin = 'TemplateSettingsAdmin',
    TemplatesViewer = 'TemplatesViewer',
    TemplatesEditor = 'TemplatesEditor',
    TemplatesAdmin = 'TemplatesAdmin',
    WebhookLogsViewer = 'WebhookLogsViewer',
    WebhookLogsAdmin = 'WebhookLogsAdmin',
    WebhookPreferencesViewer = 'WebhookPreferencesViewer',
    WebhookPreferencesEditor = 'WebhookPreferencesEditor',
    WebhookPreferencesAdmin = 'WebhookPreferencesAdmin',
    WizardsAdmin = 'WizardsAdmin',
    ZipCodesAdmin = 'ZipCodesAdmin',
    UserProfilesViewer = 'UserProfilesViewer',
    UserProfilesEditor = 'UserProfilesEditor',
    UserProfilesAdmin = 'UserProfilesAdmin',
    IntakeFormTemplatesViewer = 'IntakeFormTemplatesViewer',
    IntakeFormTemplatesEditor = 'IntakeFormTemplatesEditor',
    IntakeFormTemplatesAdmin = 'IntakeFormTemplatesAdmin',
}

export default Roles
